import type { CloseActivitySummaryAction } from './typings'

export const closeActivitySummaryActionCreator =
  (): CloseActivitySummaryAction => ({ type: 'activitySummary/close' })
